import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useState, useEffect } from "react";
import { CartHeader } from "./cart/CartHeader";
import { CartContent } from "./cart/CartContent";
import { CartFooter } from "./cart/CartFooter";
import { useNewCart } from "@/hooks/useNewCart";
import { useCartValidation } from "./hooks/useCartValidation";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";

interface CartDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  refetch: () => void;
}

export const CartDialog = ({
  open,
  onOpenChange,
  refetch,
}: CartDialogProps) => {
  const navigate = useNavigate();
  const [digitalSignature, setDigitalSignature] = useState("");
  const [isCredit, setIsCredit] = useState(false);
  const [partialPayment, setPartialPayment] = useState("");
  const [paymentDueDate, setPaymentDueDate] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerContact, setCustomerContact] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");

  const { 
    cartItems, 
    isLoading,
    handleRemoveItem
  } = useNewCart();

  const { loading, handleValidateCart } = useCartValidation({
    cartItems,
    digitalSignature,
    isCredit,
    partialPayment,
    paymentDueDate,
    customerName,
    customerContact,
    customerAddress,
    paymentMethod,
    onSuccess: () => {
      onOpenChange(false);
      refetch();
    },
  });

  useEffect(() => {
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate('/login-owner');
      }
    };
    
    checkAuth();
  }, [navigate]);

  if (isLoading) {
    return <div>Chargement...</div>;
  }

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      return total + (parseFloat(item.stock_item.data.price) * item.quantity);
    }, 0);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
        <CartHeader />
        
        <div className="flex-1 overflow-y-auto min-h-0 py-4">
          <CartContent
            digitalSignature={digitalSignature}
            setDigitalSignature={setDigitalSignature}
            cartItems={cartItems}
            handleRemoveItem={handleRemoveItem}
            isCredit={isCredit}
            setIsCredit={setIsCredit}
            partialPayment={partialPayment}
            setPartialPayment={setPartialPayment}
            paymentDueDate={paymentDueDate}
            setPaymentDueDate={setPaymentDueDate}
            customerName={customerName}
            setCustomerName={setCustomerName}
            customerContact={customerContact}
            setCustomerContact={setCustomerContact}
            customerAddress={customerAddress}
            setCustomerAddress={setCustomerAddress}
            calculateTotal={calculateTotal}
            onPaymentMethodChange={setPaymentMethod}
            paymentMethod={paymentMethod}
          />
        </div>

        <div className="border-t pt-4 mt-auto">
          <CartFooter
            calculateTotal={calculateTotal}
            loading={loading}
            cartItems={cartItems}
            digitalSignature={digitalSignature}
            paymentMethod={paymentMethod}
            onCancel={() => onOpenChange(false)}
            onValidate={handleValidateCart}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};